import { useState, useRef, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { firebaseDB } from '../../firebase-config';
import { Button } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Slider from 'react-slick';
import { WeatherFutureContext, useAuth } from '../../contexts';
import { formatDateArray } from '../../format-date';
import { AdvicesCards, UserAdvicesCards } from '../advices';
import { Loading } from '../components';
import { WeatherFutureCard, TempChart, Winter, Humidity } from './componets';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './weather-future.scss';
import { SETTINGS } from '../../consts/slick-const';

export const WeatherFuture = ({ cityName }) => {
    const [temp, setTemp] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [showId, setShowId] = useState('');
    const [userChildren, setUserChildren] = useState([]);
    const [widthWindow, setWidthWindow] = useState(window.innerWidth);

    const future = useContext(WeatherFutureContext);
    const customeSlider = useRef();
    const { user } = useAuth();
    const usersChildrenCollectionRef = user &&
        collection(firebaseDB, `usersChildren/${user.uid}/children`);
    const humidityData = future.map(item => [formatDateArray(item.dt_txt), item.main.humidity]).slice(0, 17);
    const winterData = future.map(item =>
        [formatDateArray(item.dt_txt), item.wind.deg, Math.ceil(item.wind.speed), Math.ceil(item.wind.gust)]
            .slice(0, 17)
    );
    const tempChartData = widthWindow <= 650 ? future.slice(0, 17) : future;
    const handleExpandClick = (temper, date, id) => {
        const corectDate = date.substr(0, 16);
        setShowId(id);
        setTemp({ temper, corectDate });
        id !== showId && setExpanded(true);
        id === showId && setExpanded(false);
        (id === showId && expanded === false) && setExpanded(true);
    };
    const handleNoShowAllAdvice = () => {
        setShowId('');
        setExpanded(false);
    };
    const handlerPrev = () => customeSlider.current.slickPrev();
    const handlerNext = () => customeSlider.current.slickNext();
    const updateDimensions = () => setWidthWindow(window.innerWidth);

    useEffect(() => {
        const getUserChildren = async () => {
            const data = await getDocs(usersChildrenCollectionRef);
            setUserChildren(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        };
        user && getUserChildren();
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    return (
        <>
            {(!future.length && !Object.keys(future).length) ?
                <Loading /> :
                <div className='weather-future'>
                    <h2>{cityName}</h2>
                    <div className='weather-future_btn-wrapper'>
                        <Button variant='contained'
                            sx={{
                                marginRight: '10px',
                                backgroundColor: '#6565f5',
                                '&:hover': { backgroundColor: '#4d4de9' },
                                '@media (max-width: 390px)': { margin: '0 0 10px 0' }
                            }}
                            onClick={handleNoShowAllAdvice}>
                            Сховати всі поради
                        </Button>
                        <div className='weather-future_slick-arrows'>
                            <Button
                                variant='contained'
                                sx={{
                                    backgroundColor: '#6565f5',
                                    '&:hover': { backgroundColor: '#4d4de9' }
                                }}
                                onClick={handlerPrev}>
                                <NavigateBeforeIcon />
                            </Button>
                            <Button
                                variant='contained'
                                sx={{
                                    marginLeft: '6px',
                                    backgroundColor: '#6565f5',
                                    '&:hover': { backgroundColor: '#4d4de9' }
                                }}
                                onClick={handlerNext}>
                                <NavigateNextIcon />
                            </Button>
                        </div>
                    </div>
                    <Slider {...SETTINGS} ref={customeSlider}>
                        {future.map((weather, index) => (
                            <WeatherFutureCard
                                key={index}
                                weather={weather}
                                index={index}
                                showId={showId}
                                expanded={expanded}
                                handleExpandClick={handleExpandClick} />
                        ))}
                    </Slider>
                    {expanded &&
                        <div className='weather-future_advices'>
                            <h3 className='weather-future_advices_header'>
                                Поради на {temp.corectDate}
                            </h3>
                            {!userChildren.length ?
                                <AdvicesCards temperature={temp.temper} /> :
                                <UserAdvicesCards temperature={temp.temper} userChildren={userChildren} />}
                        </div>
                    }
                    <TempChart data={tempChartData} widthWindow={widthWindow} />
                    <Winter data={winterData} />
                    <Humidity data={humidityData} />
                    <Outlet />
                </div>
            }
        </>
    )
}
